import React from "react";
import { ModeRendererProps } from "./types";

export function AgamogramMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <g clipPath="url(#circleClip)" mask="url(#stripeEven)">
        <rect x="0" y="0" width="794" height="1123" fill="url(#diamond)" />
        <g transform="translate(397 540)">
          {Array.from({ length: 8 }).map((_, i) => (
            <circle key={i} r={60 + i * 28} fill="none" stroke={brand.aqua} strokeWidth="2" opacity={0.4} />
          ))}
        </g>
      </g>
      <g clipPath="url(#circleClip)" mask="url(#stripeOdd)">
        <rect x="0" y="0" width="794" height="1123" fill="url(#checker)" />
        <g transform="translate(397 540)">
          {Array.from({ length: 8 }).map((_, i) => (
            <circle key={i} r={60 + i * 28} fill="none" stroke={brand.amber} strokeWidth="2" opacity={0.4} />
          ))}
        </g>
      </g>
      <circle cx="397" cy="540" r="310" fill="none" stroke={brand.white} strokeWidth="2" />
    </g>
  );
}
